import { Outlet, Navigate, useLocation } from "react-router-dom";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { AppHeader } from "./AppHeader";
import { ImpersonationBanner } from "./ImpersonationBanner";
import { useAuth } from "@/auth/AuthContext";
import { AuthSplash } from "./AuthSplash";

export function AppLayout() {
  const { user, employee, impersonating, loading, linkError } = useAuth();
  const location = useLocation();
  if (loading) return <AuthSplash />;
  // If Clerk authenticated but the backend rejected (no `clerkUserId` link),
  // route to /login so the link-error screen surfaces — don't bounce in a
  // tight loop, since Clerk still considers them signed in.
  // An employee with no admin row belongs in the employee lane, not at the
  // login screen — sending them there would loop, since Clerk still considers
  // them signed in (FEAT-2026-013).
  if (!user && employee) return <Navigate to="/me" replace />;
  if (!user && linkError) return <Navigate to="/login" replace state={{ from: location }} />;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  // Super admins only enter the tenant portal via impersonation; otherwise send them to platform console.
  if (user.roleType === "super_admin" && !impersonating) return <Navigate to="/platform" replace />;

  return (
    <SidebarProvider defaultOpen>
      <div className="flex min-h-screen w-full bg-background">
        <AppSidebar />
        <div className="flex min-w-0 flex-1 flex-col">
          <ImpersonationBanner />
          <AppHeader />
          <main className="flex-1 p-4 md:p-6 lg:p-8 animate-fade-in">
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
